// Routes whose page data comes from authenticated control-plane or broker
// endpoints. Keeping this list separate from main.tsx makes omissions
// regression-testable without importing the application bootstrap.
export const PROTECTED_PATHS: string[] = [
  '/',
  '/dashboard-v12',
  '/cockpit',
  '/auto-trading',
  '/audit',
  '/broker',
  '/v14',
  '/realtime-scoring',
  '/admin',
  '/paper-audit',
  '/observability',
  '/replay',
  '/settings',
  '/databases',
];
